import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=69fc53ea&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.styl?vue&type=style&index=0&id=69fc53ea&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc53ea",
  null
  
)

export default component.exports